import { CanActivate, Router, ActivatedRouteSnapshot, ActivatedRoute, RouterStateSnapshot } from '@angular/router';
import {Injectable} from '@angular/core';
import {LOCALSTORAGE_AUTH} from '../../setup/configurations';
import { JwtHelperService } from './services/jwt-helper.service';
import * as authenticationTypes from '../authentication/types';

@Injectable()
export class AuthenticatedGuard implements CanActivate {
  username: string = '';
  routeURL: string;

  constructor(private router: Router, private jwt: JwtHelperService) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    this.username = route.queryParams['username'] || '';

    return this.guard(false);
  }

  private guard(navigate: boolean): boolean {
    this.routeURL = this.router.url;

    const auth = localStorage.getItem(LOCALSTORAGE_AUTH);
    //console.log('url ' + this.routeURL);

    if (auth) {
      const token = (<authenticationTypes.ILoginResult>JSON.parse(auth)).token;
      if (!this.jwt.isTokenExpired(token)) {
        //console.log("session valid");
        return true;// return true if session is valid
      }
      else
      {
        console.log("session expired");// redirect and return false later
      }
    }
    else
    {
      console.log("not authorized");// redirect and return false later
    }

    // not logged in so redirect to login page, never happened? if it happens it will be an infinite loop
    //if (navigate) {
      //console.log("redirect");
      //this.router.navigate(['/authentication'], { queryParams: { username: this.username } });
    //}

    if (this.routeURL != "/authentication?username=") // avoid infinite loop
    {
      // redirect to login page once only, if session is invalid, and return false
      console.log("redirected to login page");
      this.router.navigate(["/authentication"], { queryParams: { username: this.username } });

    }
    return false;// stop navigation
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/authenticated.guard.ts